export async function authFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem("ec_token");
  const headers: Record<string, string> = {
    ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
    ...(options.headers as Record<string, string> || {}),
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  const response = await fetch(url, { ...options, headers });
  if (response.status === 401 && token && url !== "/api/espace-client/me") {
    localStorage.removeItem("ec_token");
    window.location.replace("/login");
    return response;
  }
  if (response.status === 403 && window.location.pathname !== "/change-password") {
    const error = await response.clone().json().catch(() => null);
    if (error?.code === "PASSWORD_CHANGE_REQUIRED") {
      window.history.pushState(null, "", "/change-password");
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  }
  return response;
}
